module.exports = __webpack_public_path__ + "static/media/princess.0ba11e6a.gif";